const omitEmptyValues = (obj: object) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null && value !== '' && value !== undefined),
  );
};

export default omitEmptyValues;
